import React from 'react'
import PropTypes from 'prop-types'
import AnimateChildren from './AnimateChildren'

/**
 * A wrapper component that animates SlideIn on it's children
 */

function SlideIn (props) {
  const {
    direction = 'left-to-right',
    distance = '50px'
  } = props

  const defaultStyles = {
    transition: `all ${props.duration}ms ease`,
    transitionProperty: 'opacity, transform'
  }

  let transitionStyles

  if (direction === 'left-to-right') {
    transitionStyles = {
      entering: { opacity: 0, transform: `translateX(-${distance})` },
      entered: { opacity: 1, transform: 'translateX(0px)' },
      exiting: { opacity: 0, transform: `translateX(${distance})` },
      exited: { opacity: 0 }
    }
  }

  if (direction === 'right-to-left') {
    transitionStyles = {
      entering: { opacity: 0, transform: `translateX(${distance})` },
      entered: { opacity: 1, transform: 'translateX(0px)' },
      exiting: { opacity: 0, transform: `translateX(-${distance})` },
      exited: { opacity: 0 }
    }
  }

  if (direction === 'right') {
    transitionStyles = {
      entering: { transform: `translateX(${distance})` },
      entered: { transform: 'translateX(0px)' },
      exiting: { transform: `translateX(${distance})` },
      exited: { transform: `translateX(${distance})` }
    }
  }

  return React.createElement(
    AnimateChildren,
    {
      transitionStyles: transitionStyles,
      defaultStyles: defaultStyles,
      ...props
    })
}

SlideIn.propTypes = {
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.any,
  /**
   * unmountOnExit, unmounts the component when the exit animation finishes (default true)
   */
  unmountOnExit: PropTypes.bool,
  /**
   * How long the animation should last
   */
  duration: PropTypes.number
}

export default SlideIn
